/*******************************************************************
 * Generated by RxDjango on 2026-07-16 12:17 (UTC)                 *
 *                                                                 *
 * Based on all ContextChannel subclasses in simple_model.channels *
 *                                                                 *
 *                      DO NOT EDIT THIS FILE                      *
 *                                                                 *
 * To rebuild it, run:                                             *
 *                                                                 *
 *     ./manage.py makefrontend [simple_model]                     *
 *                                                                 *
 *******************************************************************/

import { ContextChannel } from '@rxdjango/react';
import type { User } from './simple_model.models';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class SimpleModelChannel extends ContextChannel {

  protected endpoint: string = "/ws/simple_model/";
  protected baseURL: string = SOCKET_URL;

  user: User | null = null;

  protected _modelFields: Record<string, {
      anchor: string;
      model: Record<string, Record<string, string>>;
      many?: boolean;
    }> = {
      "user": {
        anchor: "simple_model.serializers.UserSerializer",
        model: {
          "simple_model.serializers.UserSerializer": {  },
        },
      },
    };

  authorize = async (password: string) => {
    return await this.rx.callAction('authorize', [password]);
  };
}
